import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { STRINGS } from "./translations";

const LanguageContext = createContext(null);

const detect = () => {
  const saved = localStorage.getItem("aiba_lang");
  if (saved === "fr" || saved === "en") return saved;
  const nav = (navigator.language || "en").toLowerCase();
  return nav.startsWith("fr") ? "fr" : "en";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(detect);

  useEffect(() => {
    localStorage.setItem("aiba_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => setLangState(l);
  const toggle = () => setLangState((l) => (l === "fr" ? "en" : "fr"));

  const t = useMemo(() => {
    const dict = STRINGS[lang] || STRINGS.en;
    const fallback = STRINGS.en;
    return (path) => {
      const walk = (obj) => path.split(".").reduce((o, k) => (o == null ? undefined : o[k]), obj);
      const val = walk(dict);
      return val !== undefined ? val : (walk(fallback) !== undefined ? walk(fallback) : path);
    };
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, toggle, t }), [lang, t]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
